<div class="db-download-manager-connect__content">
  <div class="db-download-manager-connect__header">
    <h2 class="mb5">Connect your website</h2>
    <p class="mb50">Install 10Web Manager Plugin to connect your website to 10Web</p>
  </div>

  <ul class="db-download-manager-connect__steps">
    <li><i class="db-icon db-icon-ds-checkmark-bg"></i> Download 10Web Manager Plugin
      <a class="ds-btn-blue ml8" [href]="downloadLink$ | async" download (click)="downloadManagerPluginEvent()">
        <span><i class="db-icon db-icon-ds-download"></i>Download</span>
      </a>
    </li>
    <li><i class="db-icon db-icon-ds-checkmark-bg"></i> Install and activate the plugin from the WP admin</li>
  </ul>

</div>

<div class="db-download-manager-connect__banner"></div>
